import React, { useContext, useEffect, useState, useRef } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context';
import Table from '../../../components/Table';
import Button from '../../../components/Button';
import Modal from './extraModal/AchieveModal'
import { useSelector, useDispatch } from 'react-redux';
import CustomSelect from '../../../components/CustomSelect';
import { getStudentSpecialistRecordTerms, createEducationRecord, updateEducationRecord, deleteEducationRecord } from '../../../actions/students/other';
import Confirmation from '../../../components/Confirmation/Confirmation';


export default function SpecialistRecords() {
  const dispatch = useDispatch()

  const { allForms, addMode, studentTabData, updateInitialValues, studentId } = useContext(StudentsContext)

  const { values, setValues } = allForms

  const { specialist_records: specialistData } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  const [modalData, setModalData] = useState(null)
  const [modalAddMode, setModalAddMode] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

  const { specialistTerms } = useSelector(state => state.students.data)
  const [term, setTerm] = useState('')

  useEffect(() => {
    if (studentId) dispatch(getStudentSpecialistRecordTerms(studentId))
  }, [studentId]) // eslint-disable-line

  useEffect(() => {
    const dataJson = JSON.stringify(specialistData)
    if (!addMode && specialistData && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({
        ...prev,
        specialist_records: [...specialistData]
      }))
      if (updateInitialValues) {
        updateInitialValues('specialist_records', specialistData)
      }
    }
  }, [specialistData, addMode, setValues, updateInitialValues])

  const handleTermChange = (name, value) => {
    setTerm(value)
    setSelectedRow(null)
  }

  const handleAdd = () => {
    setModalAddMode(true)
    setModalData({})
  }

  const handleEdit = () => {
    const items = values.specialist_records || []
    if (selectedRow !== null && items[selectedRow]) {
      setModalAddMode(false)
      setModalData(items[selectedRow])
    }
  }

  const handleDeleteClick = () => {
    const items = values.specialist_records || []
    if (selectedRow !== null && items[selectedRow]) {
      setShowDeleteConfirm(true)
    }
  }

  const confirmDelete = () => {
    const items = values.specialist_records || []
    const item = items[selectedRow]
    if (item) {
      dispatch(deleteEducationRecord(studentId, 'specialist_records', item.piid))
    }
    setSelectedRow(null)
    setShowDeleteConfirm(false)
  }

  const closeModal = () => {
    setModalData(null)
  }

  const toInt = (v) => (v !== '' && v != null ? parseInt(v, 10) : undefined)

  const buildPayload = ({ piid, name, author, idauthor, modified, term_title, ...rest }) => ({
    ...rest,
    section_id: toInt(rest.section_id),
    trmid: toInt(rest.trmid),
  })

  const handleSaveItem = (itemData) => {
    const payload = buildPayload(itemData)
    if (modalAddMode || !itemData.piid) {
      dispatch(createEducationRecord(studentId, 'specialist_records', payload))
    } else {
      dispatch(updateEducationRecord(studentId, 'specialist_records', itemData.piid, payload))
    }
    closeModal()
    setSelectedRow(null)
  }

  const termOptions = [
    { name: 'Все', value: '' },
    ...(specialistTerms || []).map(t => ({ name: t.term_title || t.term_name, value: t.trmid }))
  ]

  const displayItems = (values.specialist_records || []).filter(item =>
    !term || String(item.trmid) === String(term)
  )

  const renderLi = (item, idx) => {
    const { section, name, author, quarter, term_title, modified, created_at, content, for_parents, for_teachers, for_educators, for_tutors } = item
    return (
      <tr
        key={item.piid || item.id || idx}
        onClick={() => setSelectedRow(idx)}
        style={{ cursor: 'pointer', backgroundColor: selectedRow === idx ? '#DEECFF' : 'transparent' }}
      >
        <td>{section || name || ''}</td>
        <td>{author || ''}</td>
        <td>{quarter || term_title || ''}</td>
        <td>{modified || created_at || ''}</td>
        <td>{content || ''}</td>
        <td>{for_parents ? 'Да' : 'Нет'}</td>
        <td>{for_teachers ? 'Да' : 'Нет'}</td>
        <td>{for_educators || for_tutors ? 'Да' : 'Нет'}</td>
      </tr>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      {modalData !== null &&
        <Modal
          closeModal={closeModal}
          data={modalData}
          height={'540px'}
          addMode={modalAddMode}
          tabType='specialist_records'
          onSave={handleSaveItem}
          specialistTerms={specialistTerms}
        />
      }

      {showDeleteConfirm && (
        <Confirmation
          title='Вы уверены, что хотите удалить запись?'
          acceptConfirmation={confirmDelete}
          rejectConfirmation={() => setShowDeleteConfirm(false)}
        />
      )}

      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Учебный период'
            valuesName="term"
            options={termOptions}
            width={300}
            value={term}
            setFieldValue={handleTermChange}
            withoutAll
          />
        </div>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th>Раздел</th>
              <th>Автор</th>
              <th>Четверть</th>
              <th>Внесено</th>
              <th>Содержание</th>
              <th>Родителям</th>
              <th>Преподавателям</th>
              <th>Воспитателям</th>
            </tr>
          </thead>
          <tbody>
            {displayItems.map(renderLi)}
          </tbody>
        </Table>
        <div className={styles.inputsRow} style={{ marginTop: '0.5rem' }}>
          <Button mode='bordered' onClick={handleAdd}>Добавить</Button>
          <Button mode='bordered' onClick={handleEdit} disabled={selectedRow === null}>Изменить</Button>
          <Button mode='bordered' onClick={handleDeleteClick} disabled={selectedRow === null}>Удалить</Button>
          <Button mode='bordered' onClick={() => { }}>Печать</Button>
        </div>
      </div>
    </div>
  )
}
